
import * as constants from "../constants/CONSTANT";

let tenantcode = sessionStorage.getItem("schoolcode") || "";

const authApi = {
  async login(username, schoolcode, password) {
    try {
      console.log("Login Details =>", username, schoolcode, password);

      if (schoolcode) {
        tenantcode = schoolcode;
        sessionStorage.setItem("schoolcode", schoolcode);
      }

      // const baseApiUrl = `https://crm.idigischool.com/ibs`;
      const baseApiUrl =
        window.location.hostname === "localhost"
          ? "http://localhost:4010/ibs"
          : `https://crm.idigischool.com/ibs`;

      //  const baseApiUrl = `http://localhost:4010/ibs`;
      // const baseApiUrl = `https://d7nql637-4010.inc1.devtunnels.ms`;
      //const baseApiUrl = `${constants.API_BASE_URL}`;

      let response = await fetch(`${baseApiUrl}/api/auth/login`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          schoolcode,
          password,
        }),
      });

      console.log("result->", response);
      const result = await response.json();
      console.log("result->", result);

      if (result.success) {
        console.log("result->", result);
        sessionStorage.setItem("token", result.authToken);
      }

      return result;
    } catch (error) {
      console.error("Login failed:", error);
      return { success: false, message: error.message };
    }
  },

  async fetchMyImage() {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token found.");
      }

      let response = await fetch(`${tenantcode}/api/auth/myimage`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        return await response.blob();
      } else {
        throw new Error("Failed to fetch image.");
      }
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  },

  logout() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("permissions");
    // sessionStorage.removeItem("schoolcode");
    window.location.href = "/login";
  },
};

export default authApi;
